
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const formatSlug = (text) => {
  return text?.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
};

const XMLPage = ({ matchingProducts, statesCitiesData }) => {
  const { pageNumber } = useParams();
  const [urlsChunk, setUrlsChunk] = useState([]);
  const urlsPerPage = 50000;

  useEffect(() => {
    let allUrls = [];

    matchingProducts?.forEach((product) => {
      const productSlug = formatSlug(product.name);
      statesCitiesData?.forEach((stateItem) => {
        const stateSlug = formatSlug(stateItem.state);
        allUrls.push(`https://www.vanshikaplastic.com/${productSlug}-in-${stateSlug}`);
        stateItem.cities?.forEach((city) => {
          const citySlug = formatSlug(city);
          allUrls.push(`https://www.vanshikaplastic.com/${productSlug}-in-${citySlug}`);
        });
      });
    });

    const chunkUrls = (urls, chunkSize) => {
      let chunks = [];
      for (let i = 0; i < urls.length; i += chunkSize) {
        chunks.push(urls.slice(i, i + chunkSize));
      }
      return chunks;
    };

    const urlChunks = chunkUrls(allUrls, urlsPerPage);
    const currentChunk = urlChunks[parseInt(pageNumber) - 1];
    setUrlsChunk(currentChunk || []);
  }, [matchingProducts, statesCitiesData, pageNumber]);

  return (
    <div className="container py-4">
      <h4>XML Sitemap Page {pageNumber}</h4>
      <pre style={{ backgroundColor: "#f8f9fa", padding: "1rem", borderRadius: "5px" }}>
        {`<?xml version="1.0" encoding="UTF-8"?>\n<urls>\n`}
        {urlsChunk.map((url, index) => `  <url>${url}</url>\n`)}
        {`</urls>`}
      </pre>
    </div>
  );
};

export default XMLPage;
